import { Router } from "@angular/router";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Globals } from "../../globals";
import { MatDialog } from "@angular/material";
import { FinanciamientoApiService } from "src/app/services/financiamiento-reusable.service";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { Response } from 'src/app/models/response';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  route: string;
  initToken: any;
  mostrar = false;
  width = "35%";
  height = null;
  flagMensaje: boolean;
  flagToForm: boolean;
  datos: FormGroup;
  mensaje: string;
  codiMensaje: string;
  titulo: string;
  validaDoc: number = 0;
  maxLength: string;

  codCliente: number;
  secuSuministro: number;
  codOficina: number;
  parentesco: string;

  error: {};
  tiposDocumento = [
    {
      tipo: "",
      descripcion: "<<Seleccione>>",
    },
  ];
  mensajes = [];
  validarSolitante: number;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    //private acuerdosApiService: AcuerdosApiService,
    private financiamientoApiService: FinanciamientoApiService,
    /* add code verify */
    public dialog: MatDialog,
    private globals: Globals
  ) {
    /* this.initToken = localStorage.getItem(environment.initialToken);
    this.route = this.router.url.replace('/', '');
    this.route = this.route.split('/')[0];
    */

    this.blockUI.start();

    this.datos = new FormGroup({
      suministro: new FormControl("", Validators.required),
      tipDocumento: new FormControl("", Validators.required),
      numDocumento: new FormControl("", Validators.required),
    });
  }

  finsihImagenes() {
    this.mostrar = true;
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  ngOnInit() {
    this.blockUI.start('Espere por favor...');
    this.titulo = 'Afiliación al Recibo Digital';
    this.validarSolitante = 0;
    let suministro = (
      document.getElementsByName("suministro")[0] as HTMLInputElement
    ).value;
    let tipo_documento = (
      document.getElementsByName("tipo_documento")[0] as HTMLInputElement
    ).value;
    let numero_documento = (
      document.getElementsByName("numero_documento")[0] as HTMLInputElement
    ).value;

    /*this.datos.value.suministro = suministro;
    this.datos.value.tipDocumento = String(tipo_documento);
    this.datos.value.numDocumento = String(numero_documento);*/

    /* if (this.globals.app_title === "") {
       this.toastr.warning("Seleccionar el tipo de tramite (Financimiento, Fraccionamiento y Recibo Digital)", "Atención", {
         timeOut: 2500,
       });
       //SOLO PARA DESARROLLO
       this.router.navigate(["/servicios"]);
       return;
     }*/

    this.mensajes = [
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG001",
        "valor": "Debe ingresar el Suministro, el Tipo y Número de Documento",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG002",
        //"valor": "Debe ingresar un Número de Suministro.",
        "valor": "Debe ingresar el Suministro",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG003",
        "valor": "Debe seleccionar un Tipo de Documento",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG004",
        "valor": "Debe ingresar un Número de  Documento",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG005",
        "valor": "Los datos ingresados no existen, por favor regístrese",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG006",
        "valor": "Suministro no válido. Ubique el suministro en la parte superior derecha de su recibo.",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG007",
        "valor": "No se encontró el tipo y número de documento del cliente",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG008",
        "valor": " ",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG009",
        //"valor": "El suministro no debe ser de grandes clientes ni de fuente propia",
        "valor": "Usted pertenece a nuestra Cartera de Clientes Especiales y/o Fuente Propia, para quienes actualmente no se encuentra habilitada esta opción, agradeceremos comunicarse al 317-8000 (Aquafono)",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG010",
        "valor": "Error: Debe ingresar 8 digitos si el tipo de documento es DNI",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG011",
        "valor": "Error: Debe ingresar 11 digitos si el tipo de documento es RUC",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "MSG012",
        "valor": "Error: El Suministro debe contar con 7 dígitos",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      },
      {
        "usuario": "lizardo",
        "fechaActual": 1630150626000,
        "programa": "manual",
        "codiOficina": 0,
        "clase": "MENSAJES_VALIDA_FINANCIAMIENTO",
        "categoria": "suministroIndividualizado",
        "valor": "Este Suministro es un hijo no individualizado, consulte el Suministro padre.",
        "flag": "1",
        "fechaAlta": 1630150626000,
        "fechaBaja": 32503611600000,
        "modulo": "FINANCIAMIENTO_WEB"
      }
    ];

    //Obtener titulo
    const body = {
      tipoTitulo: 'WT003'
    };
    this.financiamientoApiService.getTipos(body).subscribe((response) => {
      // this.titulo = response.resultado.descTipoDet;
      //Obtener Tipos de Docmuento
      this.financiamientoApiService.getTipoDocumentos().subscribe((response2) => {
        this.tiposDocumento = this.tiposDocumento.concat(response2.resultado);
        //this.consultaUrlFraccionamiento();
        /*
        //Obtener mensajes por parametros gc
        const body1 = {
          clase: "MENSAJES_VALIDA_FINANCIAMIENTO",
          modulo: "FINANCIAMIENTO_WEB",
          categoria: ""
        };
        this.financiamientoApiService
          .getParametrosGc(body1)
          .subscribe((response3) => {
            console.log (response3);
            this.mensajes = response3.resultado;
        });
        */
      });
    });


  }

  consultaUrlFraccionamiento() {
    //LRIOS INICIO
    //leer parametro y guardarlo en global
    const body = {
      clase: "FR_DIRECTORIO_TRABAJO",
      modulo: "FRACCIONAMIENTO_WEB",
      categoria: "URL_WEB"
    };
    this.financiamientoApiService.getParametrosGc(body).subscribe((response) => {
      this.globals.url_navegacion = response.resultado.find((x) => x.categoria == "URL_WEB").valor;
      sessionStorage.setItem("data_url", this.globals.url_navegacion);
    });
    //LRIOS FIN
  }

  irRegistro() {
    let data: any = {
      codCliente: this.codCliente,
      secuSuministro: this.secuSuministro,
      codOficina: this.codOficina,
      parentesco: this.parentesco
    };

    this.router.navigate(["/registro"]);
  }

  irServicios() {
    this.router.navigate(["/servicios"]);
  }

  stripChanges() {
    this.datos["controls"]["numDocumento"].setValue("");
    let tipDoc = this.datos.value.tipDocumento;
    if (tipDoc == "TD001") {
      //DNI
      this.validaDoc = 1; //numerico
      this.maxLength = '8';
    } else {
      if (tipDoc == "TD002") {
        //RUC
        this.validaDoc = 1; //numerico
        this.maxLength = '11';
      } else {
        if (tipDoc == "TD003") {
          //CARNET DE EXTRANJERIA
          this.validaDoc = 2; //alfa-numerico
          this.maxLength = '12';
        } else {
          if (tipDoc == "TD005") {
            //PASAPORTE
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '12';
          } else {
            //LOS DEMAS TIPOS
            this.validaDoc = 2; //alfa-numerico
            this.maxLength = '15';
          }
        }
      }
    }
    this.flagMensaje = false;
    this.flagToForm = false;
  }

  stripValidaDocumento(event: KeyboardEvent) {

    const patternNumber = /[0-9]/;
    const patternAlfaNumeric = /[a-zA-Z0-9]/;

    const inputChar = String.fromCharCode((event).charCode);
    if (this.validaDoc == 1) {
      if (!patternNumber.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    } else {
      if (this.validaDoc == 2) {
        if (!patternAlfaNumeric.test(inputChar)) {
          // invalid character, prevent input
          event.preventDefault();
        }
      }
    }
  }

  validarsuministroTexto(event: any) {
    let suministro = event.target.value;
    let i: any
    for (i = 0; i < suministro.length; i++) {
      var code = suministro.charCodeAt(i);
      if (code < 48 || code > 57) {
        event.target.value = "";
        this.toastr.warning('El suministro debe ser sólo números', 'Atención', { closeButton: true });
        return;
      }
    }

  }

  validarDNItexto(event: any) {

    let tipDoc = event.target.value;

    if (tipDoc === "TD001" || tipDoc === "TD002") {

      let i: any
      for (i = 0; i < tipDoc.length; i++) {
        var code = tipDoc.charCodeAt(i);
        if (code < 48 || code > 57) {
          event.target.value = "";
          this.toastr.warning('El DNI debe ser sólo números', 'Atención', { closeButton: true });
          return;
        }
      }
    }

  }

  stripValidaSuministro() {
    this.flagMensaje = false;
    this.flagToForm = false;
    let suministro = this.datos.value.suministro;

    if (suministro && suministro.length < 7) {
      this.codiMensaje = "MSG012";
      this.flagMensaje = true;
      this.flagToForm = false;
      this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
      return;
    }

  }

  stripValidaNumDocumento() {

    this.flagMensaje = false;
    this.flagToForm = false;
    let tipDoc = this.datos.value.tipDocumento;
    let numDoc = this.datos.value.numDocumento;

    if (tipDoc === "TD001") {
      //DNI
      if (numDoc.length < parseInt(this.maxLength)) {
        this.codiMensaje = "MSG010";
        this.flagMensaje = true;
        this.flagToForm = false;
        this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
        return;
      }
    } else {
      if (tipDoc === "TD002") {
        //RUC
        if (numDoc.length < parseInt(this.maxLength)) {
          this.codiMensaje = "MSG011";
          this.flagMensaje = true;
          this.flagToForm = false;
          this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
        }
      }
    }
  }

  async buscar() {
    let valid = false;
    this.stripValidaSuministro();
    if (this.flagMensaje) {
      valid = false;
      return;
    }
    this.blockUI.start();
    let suministro = (
      document.getElementsByName("suministro")[0] as HTMLInputElement
    ).value;
    let tipo_documento = (
      document.getElementsByName("tipo_documento")[0] as HTMLInputElement
    ).value;
    let numero_documento = (
      document.getElementsByName("numero_documento")[0] as HTMLInputElement
    ).value;


    //console.log(suministro);
    //console.log(tipo_documento);
    //console.log(numero_documento);

    //Validaciones
    if (suministro === '' && tipo_documento === '' && numero_documento === '') {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG001").valor;
      valid = false;
    } else if (tipo_documento === '') {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG003").valor;
      valid = false;
    } else if (suministro === '') {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG002").valor;
      valid = false;
    } else if (numero_documento === '') {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG004").valor;
      valid = false;
    } else if (tipo_documento === "TD001" && numero_documento.length != 8) {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG010").valor;
    } else if (tipo_documento === "TD002" && numero_documento.length != 11) {
      this.flagMensaje = true;
      this.mensaje = this.mensajes.find((x) => x.categoria == "MSG011").valor;
    } else {
      /*if (numero_documento.length == 0) {
        this.flagMensaje = true;
        this.mensaje = this.mensajes.find((x) => x.categoria == "MSG004").valor;
      } else {
        if (suministro.length < 7) {
          this.codiMensaje = "MSG012";
          this.flagMensaje = true;
          this.flagToForm = false;
          this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
        } else {
          if (tipo_documento === "TD001") {
            //DNI
            if (numero_documento.length < parseInt(this.maxLength)) {
              this.codiMensaje = "MSG010";
              this.flagMensaje = true;
              this.flagToForm = false;
              this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
            }
          } else {
            if (tipo_documento === "TD002") {
              //RUC
              console.log("tipo_documento", tipo_documento);
              console.log("length-document-number-1", numero_documento.length);
              console.log("length-document-number-2", this.maxLength);
              console.log("length-document-number-3", parseInt(this.maxLength));
              if (numero_documento.length < parseInt(this.maxLength)) {
                this.codiMensaje = "MSG011";
                this.flagMensaje = true;
                this.flagToForm = false;
                this.mensaje = this.mensajes.find((x) => x.categoria == this.codiMensaje).valor;
              }
            }
          }
        }
      }
    } */
      this.globals.suministro = suministro;
      this.globals.tip_docum = tipo_documento.toString();
      this.globals.num_docum = numero_documento.toString();
      let entraMensaje = false;
      const aplicaValidacion = await this.validacionAcceso(suministro, tipo_documento, numero_documento, 0);
      if (aplicaValidacion > 0) {
        this.router.navigate(['/mensaje-registro']);
        entraMensaje = true;
      } else {
        // validación de cliente titulares y no titulares
        for (let i = 6; i >= 1; i--) {
          // validación de cliente registrado
          const totalResultado = await this.validacionAcceso(suministro, tipo_documento, numero_documento, i);

          if (i !== 7 && totalResultado > 0) {
            this.router.navigate(['/mensaje-registro']);
            entraMensaje = true;
            break;
          }
        }
      }      // Valida actualización de datos o registro nuevo
      if (!entraMensaje) {
        const totalResultado = await this.validacionAcceso(suministro, tipo_documento, numero_documento, 7);
        sessionStorage.setItem('suministro', suministro);
        sessionStorage.setItem('tipoDocumento', tipo_documento);
        sessionStorage.setItem('numeroDocumento', numero_documento);
        sessionStorage.setItem('registroCompleto', '0');
        if (totalResultado === 0) {
          if (!this.flagMensaje) {
            this.flagToForm = true;
            this.flagMensaje = false;
            this.mensaje = 'Los datos ingresados no existen, por favor regístrese';
          }
        } else if (totalResultado > 0) {
          this.globals.tipo_form_solicitante = 1;
          // Formulario Actualizacion
          if (!this.flagMensaje) {
            this.router.navigate(['dashboard/mensaje-financiamiento']);
          }
        }
      }

    }

    this.blockUI.stop();
  }

  async validacionAcceso(suministro: string, tipo_documento: string, numero_documento: string, caso) {

    let totalResultado = 0;
    this.flagMensaje = false;
    await this.financiamientoApiService.validarSolicitante(Number(suministro), tipo_documento, numero_documento, caso).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            this.globals.tipo_form_solicitante = caso;
            totalResultado = response.resultado.existeSuministro;
            if (caso === 7) {
              let valorSumi = response.resultado.n_valorhijo;
              if (valorSumi < 0) {
                this.flagMensaje = true;
                this.mensaje = this.mensajes.find((x) => x.categoria == 'suministroIndividualizado').valor;
              } else {
                if (response.resultado.mensaje) {
                  this.flagMensaje = true;
                  this.mensaje = this.mensajes.find((x) => x.categoria == response.resultado.mensaje).valor;
                } else {
                  sessionStorage.setItem('dataRegistro', JSON.stringify(response.resultado));
                }
              }
            }
          }
        }
      },
      (error) => {
        console.log('Error');
      }
    );
    return totalResultado;
  }
}
